import { render, staticRenderFns } from "./billingGroups.vue?vue&type=template&id=60002b22"
import script from "./billingGroups.ts?vue&type=script&lang=js&external"
export * from "./billingGroups.ts?vue&type=script&lang=js&external"
import style0 from "./billingGroups.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports